import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

const BLUE_THEME: ThemeTypes = {
    name: 'BLUE_THEME',
    dark: false,
    variables: {
        'border-color': '#e0e6eb',
        'border-opacity': 1
    },
    colors: {
        primary: '#0f766e',
        secondary: '#0284c7',
        info: '#0ea5e9',
        success: '#16a34a',
        warning: '#f59e0b',
        error: '#e11d48',
        lightprimary: '#ccfbf1',
        lightsecondary: '#e0f2fe',
        lightsuccess: '#dcfce7',
        lighterror: '#ffe4e6',
        lightinfo: '#e0f2fe',
        lightwarning: '#fef3c7',
        textPrimary: '#0b1f2a',
        textSecondary: '#5b6b76',
        borderColor: '#d7e3ea',
        containerBg: '#b7ccc8',
        background: '#f3f8f7',
        hoverColor: '#f0fdfa',
        surface: '#ffffff',
        grey100: '#e8f2f0',
        grey200: '#1e3a3a',
        light: '#f0f9f7',
        muted: '#5b6b76'
    }
};



export { BLUE_THEME};
